import { PERMISSION_GROUPS, PERMISSION_INFO, Permission, hasPermission, type PermissionGroup, type PermissionInfo } from "@atrium/shared";

export const GROUP_TITLES: Record<PermissionGroup, string> = {
  General: "General",
  Membership: "Membership",
  Text: "Text channels",
  Voice: "Voice channels",
  Advanced: "Advanced",
};

export const flagOf = (p: PermissionInfo) => Permission[p.key];

/** The permissions set in a bitfield, in display order. */
export function permissionsIn(bits: number): PermissionInfo[] {
  return PERMISSION_INFO.filter((p) => (bits & flagOf(p)) === flagOf(p));
}

/** Permissions set in a bitfield, grouped the way role permissions are. */
export function groupedPermissions(bits: number): { group: PermissionGroup; title: string; items: PermissionInfo[] }[] {
  const list = permissionsIn(bits);
  return PERMISSION_GROUPS.map((group) => ({ group, title: GROUP_TITLES[group], items: list.filter((p) => p.group === group) })).filter((g) => g.items.length);
}

/** Whether someone with `mine` can pass `flag` on (Administrator implies everything). */
export const canGrant = (mine: number, flag: number) => hasPermission(mine, flag);
